<template>
    <div class="how-to">
        <div class="how-to__head">
            {{ getTranslatedText('T&Cs') }}
        </div>
        <div class="how-to__contents">
            <div v-if="isLoading" class="how-to__list-items__loading">
                <b-spinner />
            </div>
            <div v-if="!isLoading" class="how-to__list-items" :class="{active: isActiveContent}">
                <div class="how-to__list-item">
                    {{ titleConditions }}
                    <img
                        v-if="!isActiveContent"
                        @click="isActiveContent = !isActiveContent"
                        class="how-to__list-item__title-icon-down"
                        src="@/assets/images/static-pages/dropdown-how-to.png"
                    />
                    <img
                        v-if="isActiveContent"
                        @click="isActiveContent = !isActiveContent"
                        class="how-to__list-item__title-icon-up"
                        src="@/assets/images/static-pages/icon-up-how-to.png"
                    />
                </div>
                <div
                    v-if="isActiveContent"
                    class="how-to__list-item__content"
                    v-html="termsConditions"
                />
            </div>
        </div>
    </div>
</template>
<script>
import languageMixin from '@/mixins/language/language-mixin';
import TermsConditions from "@/services/terms-conditions.service";
export default {
    mixins: [languageMixin],
    components: {
    },
    data() {
        return {
            isActiveContent: true,
            termsConditions: '',
            titleConditions: '',
            isLoading: false
        };
    },
    created() {
      this.getDataTermsConditions();
    },
    methods: {
        getDataTermsConditions() {
            this.isLoading = true;
            const locale = localStorage.getItem("locale");
            if(locale) {
                TermsConditions.getTermsConditions(locale).then((res) => {
                    if (res.status === 200) {
                        this.termsConditions = res.data.body;
                        this.titleConditions = res.data.title;
                    }
                    this.isLoading = false;
                });
            } else {
                TermsConditions.getTermsConditions('en').then((res) => {
                    if (res.status === 200) {
                        this.termsConditions = res.data.body;
                        this.titleConditions = res.data.title;
                    }
                    this.isLoading = false;
                });
            }
        }
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/static-pages/howto.scss" />
